module.exports = __webpack_public_path__ + "static/img/onOther.d0106a54.png";